
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#00003C"}},[_c('path',{attrs:{"d":"M3.206 8.823c-2.03 3.52-.74 8.864 1.504 12.103C5.83 22.546 6.964 24 8.517 24c.03 0 .059 0 .089-.002.73-.029 1.257-.254 1.767-.47.572-.244 1.164-.497 2.093-.497.883 0 1.447.244 1.992.48.537.233 1.09.473 1.908.458 1.75-.033 2.824-1.602 3.771-2.986A13.234 13.234 0 0021.79 17.6l.006-.021a.197.197 0 00-.104-.242c-.003 0-.012-.005-.015-.006-.308-.126-3.01-1.325-3.038-4.592-.027-2.655 2.027-4.06 2.439-4.315l.019-.012a.196.196 0 00.056-.277c-1.418-2.074-3.59-2.387-4.465-2.424a3.94 3.94 0 00-.39-.02c-1.027 0-2.011.389-2.802.7-.545.216-1.017.402-1.342.402-.365 0-.84-.188-1.388-.406-.735-.292-1.567-.622-2.448-.622h-.062c-2.048.03-3.983 1.203-5.05 3.059z"}}),_c('path',{attrs:{"d":"M16.69 0c-1.24.05-2.728.814-3.618 1.856-.755.875-1.494 2.335-1.3 3.807a.197.197 0 00.18.17c.084.007.17.01.255.01 1.212 0 2.52-.671 3.414-1.751.94-1.141 1.416-2.605 1.272-3.917A.198.198 0 0016.69 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    